export const BackendURI = "epic.cg.tuwien.ac.at";
